module.exports = __webpack_public_path__ + "static/media/settings.7665671e.png";